import { CONFIRM_SHOW, CONFIRM_OK, CONFIRM_CANCEL } from '../mutation-types.js';

const localState = {
  message: 'Confirmez-vous cette action ?',
  visible: false,
  choose: null,
  callback: null,
};

// mutations
const mutations = {
  [CONFIRM_SHOW](state, {message}) {
    state.message = message;
    state.visible = true;
  },
  [CONFIRM_OK](state) {
    console.log('CONFIRM_OK');
    state.visible = false;
    state.callback(true);
  },
  [CONFIRM_CANCEL](state) {
    console.log('CONFIRM_CANCEL');
    state.visible = false;
    state.callback(false);
  }
};

// actions
const actions = {
  confirmShow({ commit, state }, payload) {
    commit(CONFIRM_SHOW, payload);

    return new Promise((resolve, reject) => {
      state.callback = (choose) => {
        resolve(choose);
      }
    })
  }
};

export default {
  state: localState,
  mutations,
  actions,
};
